export const SET_COMPLETED = "completion/SET_COMPLETED"
export const SET_COMPLETED_TIME = "completion/SET_COMPLETED_TIME"
export const SET_RESULTS = "completion/SET_RESULTS"
export const SET_IS_ALARM = "completion/SET_IS_ALARM"
export const SET_DIAGNOSIS_AGREEMENT = "completion/SET_DIAGNOSIS_AGREEMENT"
export const SET_DIAGNOSIS_HELPFULNESS = "completion/SET_DIAGNOSIS_HELPFULNESS"
export const SET_FEEDBACK = "completion/SET_FEEDBACK"
export const SET_DIAGNOSIS_EXPAND = "completion/SET_DIAGNOSIS_EXPAND"
export const SET_SUBMITTED = "completion/SET_SUBMITTED"
export const SET_HIDE_FEEDBACK = "completion/SET_HIDE_FEEDBACK"
export const SET_EMAIL = "completion/SET_EMAIL"
export const SET_PHONE_NUMBER = "completion/SET_PHONE_NUMBER"
export const SET_SHOW_FOLLOW_UP_CARD = "completion/SET_SHOW_FOLLOW_UP_CARD"
export const SET_SHOW_FOLLOW_UP_MODAL = "completion/SET_SHOW_FOLLOW_UP_MODAL"
export const SET_SHOW_MERCED_MODAL = "completion/SET_SHOW_MERCED_MODAL"
export const SET_SHOW_TIP_MODAL = "completion/SET_SHOW_TIP_MODAL"
export const SET_PROFILE_INTEREST_EMAIL =
  "completion/SET_PROFILE_INTEREST_EMAIL"
export const SET_PROFILE_INTEREST_ERROR =
  "completion/SET_PROFILE_INTEREST_ERROR"
export const SET_PROFILE_INTEREST_ATTEMPTED =
  "completion/SET_PROFILE_INTEREST_ATTEMPTED"
export const SET_PROFILE_INTEREST_SUBMITTED =
  "completion/SET_PROFILE_INTEREST_SUBMITTED"
export const SHOW_PROFILE_INTEREST_CONFIRMATION =
  "completion/SHOW_PROFILE_INTEREST_CONFIRMATION"



// WEBPACK FOOTER //
// ./assets/completion/actionTypes.js